import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { selectIsLockedRoute, selectIsLoggedIn } from '@auth/store/auth.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn$ = this.store.select(selectIsLoggedIn);

    const isLockedRoute$ = this.store.select(selectIsLockedRoute);

    return combineLatest([isLoggedIn$, isLockedRoute$, of(state.url)]).pipe(
      map(([loggedIn, lockRoute, url]) => {
        if (!loggedIn) {
          this.router.navigateByUrl('/login');
          return false;
        } else if (!!lockRoute && lockRoute !== url) {
          this.router.navigateByUrl(lockRoute);
          return false;
        }
        return true;
      })
    );
  }
}
